import React from "react";
import { FiGithub } from "react-icons/fi";

export default function Github({ github, projColor, cls }) {
 

  return (
    <div className={`github-icon ${cls}`}>
      <a href={github} target='_blank' rel='noreferrer' className={`github-icon all-icons project-${projColor}`}>
        <FiGithub size={25} className='icon' color={{ projColor } ? `var(--project-${projColor})` : "black"} />
      </a>
    </div>
  );
}
